import type { AdminRestaurant } from '../team/apiHelpers';
import {
  useSettingsOutletScroll,
  type UseSettingsOutletScrollResult,
} from '../shared/useSettingsOutletScroll';

export interface UseGeneralSettingsFormScrollArgs {
  isManager: boolean;
  restaurant: AdminRestaurant | undefined;
}

export type UseGeneralSettingsFormScrollResult = UseSettingsOutletScrollResult;

export const useGeneralSettingsFormScroll = ({
  isManager,
  restaurant,
}: UseGeneralSettingsFormScrollArgs): UseGeneralSettingsFormScrollResult =>
  useSettingsOutletScroll({ enabled: isManager && !!restaurant });
